// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../style.css\"","easilBlack":"#2c2e2f","empty":"style_empty__3QkAD","Gradient":"style_Gradient__84T0A","fadein":"style_fadein__2kHog"};